import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import { assertResponseSuccess, generateRequestID, getSwicusWebAppUrl } from '../utils/api';
export var requestAccess = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(environment, orgId, product, originProduct) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(getSwicusWebAppUrl(environment), "/v1/request-access"), {
              headers: {
                'content-type': 'application/json',
                'x-request-id': generateRequestID()
              },
              method: 'POST',
              credentials: 'include',
              body: _JSON$stringify({
                orgId: orgId,
                product: product,
                originProduct: originProduct
              })
            });

          case 2:
            result = _context.sent;
            assertResponseSuccess(result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function requestAccess(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();